<template>
    <div component="Profile" template="page" :detail="getIsDetail" :popupvisible="getIsAnyPopupVisible">
        <div class="bg">
            <div
                container="main"
                type="vertical"
                align="stretch"
                valign="top"
                padding="0"
                state="edit-"
                v-if="!loading && !fatalError"
            >
                <profile-header :isDetail="getIsDetail"></profile-header>
                <video-gallery-recorder />
                <section block="body">
                    <transition name="zoomIn">
                        <router-view view="detail" class="profile"></router-view>
                    </transition>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProfileHeader from '@/components/Profile/ProfileHeader.vue';
import Logo from '@/components/AppHeader/Logo.vue';
import VideoGalleryRecorder from '@/components/Profile/Video/Gallery/VideoGalleryRecorder.vue';

export default {
    name: 'Profile',

    components: {
        ProfileHeader,
        Logo,
        VideoGalleryRecorder,
    },

    data() {
        return {
            fatalError: false,
            loading: true,
            isDetail: false,
        };
    },

    created() {
        // Redirect ak user nema nastaveneho actora
        const user = this.$store.getters.getUser;

        if (this.$store.getters.getIsLoggedIn && user && (!user.actor_id || !user.actor)) {
            this.fatalError = true;
            this.$router.push({ name: 'error', query: { e: 'User does not have an assigned actor' } });
        }

        if (this.getIsSetActorAccessToken) {
            Promise.all([this.loadActor(this.getActorAccessToken)])
                .catch((err) => {
                    this.$env.log.error(err);
                    this.$bugsnag.notify(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        } else {
            this.loading = false;
        }
    },

    methods: {
        ...mapActions(['loadActor', 'openProfileDetail', 'closeProfileDetail', 'closeAllPopups', 'openMenuPopup']),
    },

    computed: {
        getIsDetail() {
            this.isDetail = typeof this.$route.meta.detail == 'boolean' ? this.$route.meta.detail : true;

            if (this.isDetail) {
                this.openProfileDetail();
            } else {
                this.closeProfileDetail();
            }

            return this.isDetail;
        },

        ...mapGetters([
            'getIsSetActorAccessToken',
            'getActorAccessToken',
            'getActor',
            'getIsAnyPopupVisible',
            'getIsLoggedIn',
            'getUserTermsAgreed',
        ]),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

// BLUR PRI POPUPE

[component='Profile'][popupvisible] {
    [block='body'] {
        filter: blur(5px);
    }
}

[component='Profile'] {
    .bg {
        @media (max-width: 980px) {
            padding: 0;
        }
    }

    [container='main'] {
        flex-direction: column;
        height: 100%;

        @media (min-width: 769px) {
            flex-direction: row;
            box-shadow: 0 3px 1px -2px rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 15px 0 rgb(0 0 0 / 15%) !important;
            border-radius: 20px;
        }
    }
}

// Body

[component='Profile'] [block='body'] {
    transition: 0.5s;
    transition-delay: 0s;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 50;
    min-height: 230px;

    @media (min-width: 769px) {
        position: relative;
        width: 50%;
    }

    @media (min-width: 980px) {
        background: linear-gradient(120deg, rgba(255, 255, 255, 0) 60%, #eaeaea);
        border-radius: 0px 20px 20px 0;
    }
}

// detail="true"
// Na mobile sa cenrálna plocha presunie ako nový skríín do popriedia

[component='Profile'][detail='true'] {
    [component='ProfileHeader'] {
        z-index: 40;
    }

    @media (max-width: 768px) {
        [block='body'] {
            position: absolute;
            margin: 0;
            height: 100%;
            top: 0px;
            left: 0;
            width: 100%;
            margin: 0;
            height: 100%;
            transition-delay: 0.1s;
            // margin-top: 80px;

            [block='center'] {
                // background-color: @primary;
            }
        }
    }
}
</style>
